import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8","key":"svg-0"}]]

const IconLetterPSmall = createReactComponent('outline', 'letter-p-small', 'LetterPSmall', __iconNode);

export default IconLetterPSmall;